<template>
  <v-snackbar v-model="showSnackbar" :color="color" class="subtitle-1" >{{message}} </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    showSnackbar: false,
    message: null,
    color: null,
  }),
  methods: {
    open(message, color) {
      this.showSnackbar = true
      this.message = message
      this.color = color
    },
  }
}
</script>